import { nextTick } from 'vue';
import { useViewStack } from '../util';
import { MobPlatformProviderBase } from './mob-platform-provider-base';

/**
 * @description ios搭载平台
 * @export
 * @class IosPlatformProvider
 * @extends {MobPlatformProviderBase}
 */
export class IosPlatformProvider extends MobPlatformProviderBase {
  /**
   * @description初始化
   * @return {*}  {Promise<void>}
   * @memberof IosPlatformProvider
   */
  async init(): Promise<void> {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    if (documentHeight > windowHeight) {
      // 存在安全距离
      const safeAreaBottom = documentHeight - windowHeight;
      document.body.style.setProperty(
        '--safe-area-inset-bottom',
        `${safeAreaBottom}px`,
      );
      document.body.style.setProperty('--van-back-top-bottom', `80px`);
    }

    // 适配IOS键盘弹出后视图偏移，隐藏后未恢复，导致高度异常
    document.addEventListener(
      'blur',
      () => {
        nextTick(() => {
          window.scrollTo(0, 0);
        });
      },
      true,
    );

    // 修复软键盘弹出导致visualViewport高度计算异常，导致页面整体上移
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', () => {
        document.body.style.height = `${window.visualViewport!.height}px`;
        this.handleViewport();
      });
      window.visualViewport.addEventListener('scroll', () => {
        this.handleViewport();
      });
      this.handleViewport();
    }
  }

  /**
   * 返回事件
   *
   * @memberof IosPlatformProvider
   */
  back(): void {
    const { goBack } = useViewStack();
    goBack();
  }

  /**
   * 处理视窗变化
   *
   * @return {*}  {void}
   * @memberof IosPlatformProvider
   */
  handleViewport(): void {
    const vv = window.visualViewport;
    if (vv) {
      // 处理输入框聚焦时顶部遮挡bug
      document.documentElement.style.setProperty(
        '--visual-viewport-offset-top',
        `${vv.offsetTop}px`,
      );
    }
  }
}
